import { render, staticRenderFns } from "./GrupoCompraCotacaoRespostaProdutos.vue?vue&type=template&id=3655d257&"
import script from "./GrupoCompraCotacaoRespostaProdutos.vue?vue&type=script&lang=js&"
export * from "./GrupoCompraCotacaoRespostaProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports